import {
  MODAL_HIDDEN,
  MODAL_DATA_LOADED,
  MODAL_INTERACTION,
} from '../actions/constants';
import { MODAL_COLLABORATORS } from '../util/enums/EnumModals';
import ModalCollaborators from '../components/modals/ModalCollaborators';

const INITIAL_STATE = {
  emails: [], // list of strings (email addresses)
  activityPoints: [], // list of ints (activity points for collaborators)
  disabled: [], // list of strings (email addresses that have been marked as deleted)
  admins: [], // list of strings (email addresses that have been marked as admins)
  email: '', // string (user entered an email)
  ownerEmail: null, // the email of the owner of this datasource
  ownerAp: 0, // activity points for owner
  ownerIsHerokuAddon: false, // true if the owner of datasource is a google user
  teamSizeLimit: null, // if there is a teamSizeLimit (e.g. for heroku addons) this will have an integer value
  readyForSave: false,
  saving: false,
  somethingChanged: false,
};

function interaction(state, payload) {
  switch (payload.section) {
    case 'email-change':
      return {
        ...state,
        email: payload.newValue.trim().toLowerCase(), // lowercase so they match user's email address in db
      };
    case 'add-clicked':
      return {
        ...state,
        emails: [...state.emails, state.email],
        email: '',
        somethingChanged: true,
      };
    case 'toggle': {
      const enabled = state.disabled.indexOf(payload.email) === -1;
      if (enabled) {
        return {
          ...state,
          disabled: [...state.disabled, payload.email],
          somethingChanged: true,
        };
      }
      return {
        ...state,
        disabled: state.disabled.filter((email) => email !== payload.email),
        somethingChanged: true,
      };
    }
    case 'toggleAdmin': {
      const isAdmin = state.admins.indexOf(payload.email) === -1;
      if (isAdmin) {
        return {
          ...state,
          admins: [...state.admins, payload.email],
          somethingChanged: true,
        };
      }
      return {
        ...state,
        admins: state.admins.filter((email) => email !== payload.email),
        somethingChanged: true,
      };
    }
    case 'saving':
      return { ...state, saving: true };
    default:
      return state;
  }
}

const collaborators = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case MODAL_HIDDEN:
      return INITIAL_STATE; // reset modal
    case MODAL_DATA_LOADED: {
      if (action.payload.modal === ModalCollaborators) {
        // sort collaborators by email
        const collabs = action.payload.json._collaborators
          .map((email, index) => {
            return [email, action.payload.json._activityPoints[index]];
          })
          .sort((a, b) => {
            return a[0].localeCompare(b[0]);
          });
        return {
          ...state,
          emails: collabs.map((item) => item[0]),
          activityPoints: collabs.map((item) => item[1]),
          admins: action.payload.json._admins.map((email) => email),
          ownerEmail: action.payload.json._ownerEmail,
          ownerAp: action.payload.json._ownerActivityPoints,
          ownerIsHerokuAddon: action.payload.json._ownerIsHerokuAddon,
          teamSizeLimit: action.payload.json._teamSizeLimit,
          readyForSave: action.payload.json.length > 0,
        };
      }
      return state;
    }
    case MODAL_INTERACTION: {
      if (action.payload.modalType !== MODAL_COLLABORATORS) {
        return state;
      }
      const newState = interaction(state, action.payload.props);
      return {
        ...newState,
        readyForSave: newState.emails.length > 0 && !newState.saving,
      };
    }
    default:
      return state;
  }
};

export default collaborators;
